import React from 'react';
import AppHeader from '../../../../components/Header/Header';
import AppFooter from '../../../../components/Footer/footer';
import SidebarMenu from '../../../../components/SidebarMenu';
import BannerSection from '../../../../components/BannerSection';
import SectionHeading from '../../../../components/SectionHeading';
import BreadcrumbNav from '../../../../components/BreadcrumbNav';

const caminho = [
    { label: 'Home', href: '/', icon: 'bi bi-house-door' },
    { label: 'Programa' },
    { label: 'Unidade Orgânica', href: '/programas/unidade-organica' },
    { label: 'Ciências da Saúde', href: '/programas/unidade_organica/ciencia_saude' },
    { label: 'Missão, Visão e Valores' }
];


function Missao_visao_valoresCS() {
    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
        <BannerSection
            title="Missão, Visão e Valores"
            subtitle="Unidade Orgânica de Ciências da Saúde"
            description={`Conheça a missão, visão e valores que guiam a Unidade Orgânica de Ciências da Saúde, comprometida com a excelência na formação de profissionais de saúde.`}
            backgroundImage={require('../../../../assets/img-heroUN.jpg')}
            backgroundId="instituition-Banner"
        />
        <BreadcrumbNav items={caminho} />
        <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
        <br />
        <div className="row flex-row-reverse">
            <div className="col-12 col-md-4 col-lg-3 col-xl-2">
                <SidebarMenu
                    title="Programas"
                    items={[
                    { label: "Apresentação", href: "/programas/unidade-organica/ciencia-humanas" },
                    { label: "Missão Visão e Valores", href: "/programas/unidade-organica/ciencia-humanas/missao-visao-valores" },
                    ]}
                />
                </div>
                <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div style={{marginLeft:'50px'}} className="details-magazine">
                <p className="f-reg f-20">
                <SectionHeading title="Nossa Missão" />
                    <li>Construir e difundir o conhecimento, comprometida com a formação de quadros de saúde  capazes de promover, prevenir e fornecer a assistência humanizada a sociedade.</li>
                    
                    <li>Assegurar o apoio técnico e administrativo aos departamentos da saúde e aos demais ôrgaões, serviços e organismos que integram a Unidade.
                    </li>
                </p>
                <br />
                <p className="f-reg f-20">
                    <SectionHeading title="Nossos Objectivos" />
                    Formar profissionais da mais alta qualificação, capazes de gerar e difundir conhecimento, preservar e divulgar os valores éticos e denteológico, científico, constituindo-se em Unidade Ôrganico estratégica para o desenvolvimento e melhoramento do Sistema de Saúde de Angola.
                </p>
                <br />
                <p className="f-reg f-20">
                    <SectionHeading title="Nossa Visão" />
                    <li>Formar profissionais para a vaguarda dos serviços de saúde.</li>
                    <li>Espírito altruísta e solidário para as pessoas mais vulneráveis da sociedade.</li>
                </p>
                <br />
                <p className="f-reg f-20">
                    <SectionHeading title="Nossos Valores" />
                    <li>
                        <b className="text-success">Rigor: </b>Rigidez de profissionais capazes de fornecer assistência de serviços de saúde, planificação e acompanhamento ou monitoramento dos trabalhos prestados;
                        <br /> 
                    </li>
                        
                    <li>
                        <b className="text-success">Responsabilidade:</b> Imparcialidade, qualidade, colaboração, inovação e credibilidade; 
                        <br />
                    </li>
                    
                    <li>
                        <b className="text-success">Trabalho e espírito de equipa: </b> Prontidão, espírito de sacrifício, compromisso mútuo e liderança; 
                        <br />
                    </li>

                    <li>
                        <b className="text-success">Integridade: </b>Consistentemente abraçando e praticando honestidade, verdade, assistência e humanização em tudo  
                        <br /> 
                    </li>
                    
                    <li>
                          <b className="text-success">Integridade:</b> consistentemente abraçando e praticando honestidade, verdade, assistência  e humanização em tudo o que fazemos;
                          <br />
                    </li>
                    
                    <li>
                         <b className="text-success">Respeito: </b>Tratando todas as partes interessadas com civilidade e dignidade, incluindo o espeito a identidade e a diversidade;
                         <br />
                    </li>
                     
                    <li>
                        Pela ciência e pelo trabalhos aspiramos as coisas mais elevadas.Atracada neste lema, atuação da Unidade, de valores culturais, morais, espirituais, intelectuais, ambiental, económica, e em prol da ciência humanizada;
                        <br />  
                    </li> 

                    <li>
                         <b className="text-success">Autonomia Intelectual: </b>Proporcionar um ambiente de criatividade e inovação, criando espaço para a implementação de linhas de pesquisas; que envolvem a área de saúde como jornadas científicas, extensão universitária.
                         <br /> 
                    </li>
                   
                    <li>
                         <b className="text-success">Integridade Científica: </b>Conciste no fortalecimento das actividades técnicas e cietíficas devem ser caraterizadas por independência intelectual e moral 
                         <br /> 
                    </li>
                   
                    <li>
                        <b className="text-success">Diversidade Científica: </b>Promove uma consciência global que valoriza a investigação científica, promovendo projectos e linhas de pesquisas relevantes a comunidade onde esta inserida a sociedade em geral; em diversas áreas de saber. 
                        <br /> 
                    </li>
                    
                    <li>
                         <b className="text-success">Excelência na Investiação: </b> Prossegue os mais elevados standars de ensino e investigação, com base num modelo de gestão orientyado para uma cultura de qualidade investigativa total e do mérito científico. 
                         <br /> 
                    </li>
                   
                    <li>
                         <b className="text-success">Apredizagem para a vida científica: </b> Promove a busca do conhecimento científico como forma de melhorar o bem-estar social e fortalecer a compreensão do indivíduo, extravasando as fronteiras geográficas; no ramo da saúde.   
                         <br /> 
                    </li>
                   
                    <li>
                        <b className="text-success">Cooperação: </b> Abrir-se ao mundo académico através de convénios com as instituições de saúde conotáveis de conhecimentos, a nível nacioanl, mundial na vertente de ensino e aprendizagem.
                        <br />
                    </li>
                    
                </p>
                <br />
                </div>
                <br /><br />
            </div>
        </div>
        <br />
        <br />
        <br />
        <br />
        <br />
        </main>
        <footer id="footer">
        <AppFooter />
      </footer>
        </>
    );
}

export default Missao_visao_valoresCS;